import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import LanguageSelector from './language-selector';
import { getCurrentLanguageCode } from './utils';
import { i18n } from '../i18n';
export var LanguageProvider = function (_a) {
    var children = _a.children;
    var _b = useState(getCurrentLanguageCode()), currentLanguageCode = _b[0], setCurrentLanguageCode = _b[1];
    useEffect(function () {
        var handleLanguageChanged = function () {
            setCurrentLanguageCode(getCurrentLanguageCode());
        };
        i18n.on('languageChanged', handleLanguageChanged);
        return function () {
            i18n.off('languageChanged', handleLanguageChanged);
        };
    }, []);
    return (_jsxs("div", { children: [children, _jsx(LanguageSelector, {})] }, currentLanguageCode));
};
